import React from 'react';

const Row = ({
  name = "",
  value = ""
}) => {
  return (
    <div className='tw-flex tw-justify-between tw-items-center tw-mb-1'>
      <p>{name}</p>
      <p className='tw-font-semibold tw-capitalize'>{value}</p>
    </div>
  );
}

export default Row;
